<div class="title-container" >
    <mat-icon [class.dark-mode]="this.darkMode" [svgIcon]="this.route.name"></mat-icon>
    <h4 [class.dark-mode]="this.darkMode" class="title">{{this.route.name}}</h4>
</div>